import React from 'react'
import { Button, Input, Option, Select } from '@material-tailwind/react'
const AddFaqForm = ({questions,answer,setQuestion,setAnswer,addFaq}) => {
  return (
    <div className='ml-[20rem] overflow-y-scroll'>
        <h2 className="text-center font-[NeueMedium] mt-12">Add a new FAQ</h2>
        <div className='my-2 flex items-center justify-center flex-col gap-4 ' >
        <div className='w-[350px]' >
                <Input value={questions} onChange={(e)=>setQuestion(e.target.value)} label='Question' />
            </div>
            <div className='w-[350px]' >
                <Input value={answer} onChange={(e)=>setAnswer(e.target.value)} label='Answer' />
            </div>
            <div className='flex items-center justify-end mx-2' >
            <Button onClick={addFaq} className='my-3' >Add FAQ</Button>
        </div>
        </div>
    </div>
  )
}

export default AddFaqForm